import { call, put, takeLatest } from 'redux-saga/effects';
import HeroAccountAPI from 'api-services/HeroAccountApi';
import { isSuccessResponse } from 'api-services/types/guards';
import { checkUserHelper } from '../utils/helperSagas';
import { SET_PASSCODE_PARAMS, REMOVE_PASSCODE_PARAMS } from './actionTypes';
import { setPasscodeDone, setPasscodeError, removePasscodeDone, removePasscodeError } from './actionCreators';
import { logout } from '../auth/actionCreators';
// Set Passcode
export function* setPasscodeCall(constAccessParams, action) {
    const { pin, slots } = action.data;
    // Check public API access token
    const newAccessParams = yield call(checkUserHelper, constAccessParams);
    const result = yield call(HeroAccountAPI.setPasscode, newAccessParams, pin, slots);
    if (isSuccessResponse(result)) {
        yield put(setPasscodeDone({ pin, isAutoApplied: !!result.data.auto_apply }));
    }
    else if (result.statusCode === 4) {
        yield put(logout());
    }
    else {
        yield put(setPasscodeError(result));
    }
}
export function* watchSetPasscodeCall(constAccessParams) {
    yield takeLatest(SET_PASSCODE_PARAMS, setPasscodeCall, constAccessParams);
}
// Remove Passcode
export function* removePasscodeCall(constAccessParams) {
    // Check public API access token
    const newAccessParams = yield call(checkUserHelper, constAccessParams);
    const result = yield call(HeroAccountAPI.removePasscode, newAccessParams);
    if (isSuccessResponse(result)) {
        yield put(removePasscodeDone({ isAutoApplied: !!result.data.auto_apply }));
    }
    else if (result.statusCode === 4) {
        yield put(logout());
    }
    else {
        yield put(removePasscodeError(result));
    }
}
export function* watchRemovePasscodeCall(constAccessParams) {
    yield takeLatest(REMOVE_PASSCODE_PARAMS, removePasscodeCall, constAccessParams);
}
//# sourceMappingURL=saga.js.map